import React from "react";
import "../css/ApproveModal.css";
import { CircularProgress } from "@mui/material";

const ApproveModal = ({ onApprove, isLoading ,message}) => {
  return (
    <div className="approve-modal">
      <h2 className="approve-heading">Approve</h2>
      <p className="approve-text">{message}</p>
     
      <button className="approve-button" onClick={onApprove}>
        {isLoading ? <CircularProgress size={20} color="inherit" /> : "Yes"}
      </button>
    </div>
  );
};

export default ApproveModal;
